export enum DateFormat {
  MonthDayYear = 'MM/dd/yyyy',
  DayMonthYear = 'dd/MM/yyyy',
  YearMonthDay = 'yyyy/MM/dd',
}
